export function enableHorizontalDragScroll({ mobileNative = true } = {}) {
	const els = document.querySelectorAll('[data-page="log"] .c-content');
	const isCoarsePointer = window.matchMedia?.('(pointer: coarse)').matches;
	
	//console.log(els)
	els.forEach((el) => {
		let $parent = el.querySelector(".c-history_log");
		let $inner = el.querySelector(".c-list_history");
		let $nav 	= document.querySelector(`[data-page="log"] #c-log_ym`);
		let $navBlocks = $nav.querySelectorAll(".d");
		let $lastNavBlock = $navBlocks[$navBlocks.length - 1];
		let $dot 	= $nav.querySelector(`.dot`);
		
		// 二重バインド防止
		if (el.dataset.dragScrollBound === '1') return;
		el.dataset.dragScrollBound = '1';
		
		// モバイルはブラウザの標準スクロールに任せる
		if (mobileNative && isCoarsePointer) {
		  // 縦横どちらもOS標準の慣性スクロールを使う（必要なら pan-y にして縦だけに制限も可）
		  el.style.touchAction = 'auto'; // 例: 'pan-y' にすると縦のみ
		  return;
		}
		// --- ここからデスクトップ向けのドラッグスクロール ---
		el.style.touchAction = 'none'; // ドラッグのためブラウザのパン操作は抑止
		let isDown = false;
		let startX = 0;
		let startY = 0;
		let startScrollLeft = 0;
		let startScrollTop = 0;
		
		const onPointerDown = (e) => {
		  // マウス左/タッチ以外は無視（= 右クリック・ペン等を除外）
		  if (e.pointerType === 'mouse' && e.button !== 0) return;
		  // 念のため：デスクトップ想定なのでタッチは無視
		  if (e.pointerType === 'touch') return;
		
		  isDown = true;
		  el.classList.add('is-dragging');
		  el.setPointerCapture?.(e.pointerId);
		  startX = e.clientX;
		  startY = e.clientY;
		  startScrollLeft = el.scrollLeft;
		  startScrollTop = el.scrollTop;
		  e.preventDefault();
		};
		
		const onPointerMove = (e) => {
		  if (!isDown) return;
		  const dx = e.clientX - startX;
		  const dy = e.clientY - startY;
		  el.scrollLeft = startScrollLeft - dx; // 横ドラッグ
		  el.scrollTop  = startScrollTop  - dy; // 縦ドラッグ（必要なければこの行を消せば横のみになる）
		  calcPosition(el.scrollLeft);
		  e.preventDefault();
		};
		
		const onPointerUp = (e) => {
		  if (!isDown) return;
		  isDown = false;
		  el.classList.remove('is-dragging');
		  el.releasePointerCapture?.(e.pointerId);
		};
		
		el.addEventListener('pointerdown', onPointerDown, { passive: false });
		el.addEventListener('pointermove', onPointerMove, { passive: false });
		el.addEventListener('pointerup', onPointerUp, { passive: true });
		el.addEventListener('pointercancel', onPointerUp, { passive: true });
		el.addEventListener('pointerleave', onPointerUp, { passive: true });
		
		// マウスホイールの縦回転を横スクロールに割り当て（トラックパッドにも有効）
		// ホイール操作も両方向に対応（縦ホイールは縦に優先）
		const onWheel = (e) => {
			if (e.shiftKey) {
				// Shift+ホイールは横スクロール
				el.scrollLeft += e.deltaY;
			} else {
				// 通常は縦スクロール（デフォルトの挙動）
				// トラックパッドの横成分も横スクロールに利用
				if (Math.abs(e.deltaX) > 0) {
					el.scrollLeft += e.deltaX;
				}
			}
		};
		el.addEventListener('wheel', onWheel, { passive: false });
		
		let calcPosition = function( left ){
			let screenW = $parent.clientWidth;
			let totalW = $inner.scrollWidth;
			let lastBlockW = $lastNavBlock.clientWidth;
			const diff    = Math.max(totalW - screenW, 1);
			const maxPosPx = (screenW - lastBlockW);
			let per = left / diff;
			if (per < 0) per = 0;
			if (per > 1) per = 1;
			const dotLeftPx = per * maxPosPx;
			//perが1の時は、screenWからlastBlockWを引いた場所に$dotを移動したい
			//console.log(dotLeftPx);
			$dot.style.left = `${dotLeftPx}px`;
			//console.log(left, diff, per);
		}
	});
}